<template>
  <v-alert
    class="mb-6"
    type="warning"
    dense
    prominent
  >
    <v-row align="center">
      <v-col class="grow">
        <span class="font-weight-medium">{{ $t('message.feature_not_available_in_current_plan') }}</span>

        <p class="mb-0">
          {{ text }}
        </p>
        <p
          v-if="isVIP"
          class="mb-0 pt-2"
        >
          {{ $t('message.talk_to_sales_to_upgrade') }}
        </p>
      </v-col>
      <v-col
        v-if="!isVIP"
        class="shrink"
      >
        <v-btn @click="upgradePlanAction">
          {{ $t('button.view_upgrade_options') }}
        </v-btn>
      </v-col>
    </v-row>
  </v-alert>
</template>

<script setup lang="ts">
import { useRouter } from 'vue-router/composables';
import { computed, PropType } from 'vue';
import store from '@/store/store';
import { BillingInfoSubscriptionStatus } from '@/model/Account';
import { TranslateResult } from 'vue-i18n';

const router = useRouter();

const isVIP = computed(() => store.state.settings.account.subStatus === BillingInfoSubscriptionStatus.VIP);

const props = defineProps({
  text: { type: [String, Object] as PropType<string|TranslateResult>, required: false, default: '' },
});

const upgradePlanAction = () => {
  router.push('/settings/billing?upgrade=true');
};

</script>
